import React from 'react';
import { ButtonCanvas } from './button_canvas';
import { Container, Title } from './styles';

interface Props {
  onClick: () => void;
}

const CanvasLogin: React.FC<Props> = (props) => {
  return (
    <Container>
      <Title>Ou faça login usando</Title>
      <ButtonCanvas onClick={props.onClick} />
    </Container>
  );
};

export { CanvasLogin };
